package one.healthium.data.user.storage

import dev.gitlive.firebase.storage.Data
import org.khronos.webgl.Uint8Array

internal actual fun ByteArray.toData(): Data {
    return Data(Uint8Array(this.toTypedArray()))
}